import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

import { environment } from '../environments/environment.prod';

declare var gtag;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  constructor(private translate: TranslateService, private router: Router) {
    translate.addLangs(['es', 'en']);

    if (localStorage.getItem('languaje') === 'es') {
      translate.use('es');
    } else if (localStorage.getItem('languaje') === 'en') {
      translate.use('en');

    } else {
      translate.setDefaultLang('es');
      localStorage.setItem('languaje', String('es'));
    }
    const navEndEvents$ = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
    );

    if (environment.Ambiente == 1) {

      // Producción
      navEndEvents$.subscribe((event: NavigationEnd) => {
        gtag('config', 'UA-171099605-1', {
          'page_path': event.urlAfterRedirects
        });
      });

    }
    else {

      // Pruebas
      navEndEvents$.subscribe((event: NavigationEnd) => {
        gtag('config', 'UA-169847108-1', {
          'page_path': event.urlAfterRedirects
        });
      });
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts